import styled from "styled-components";

export const StatusAndMetricsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

    & div[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
  `;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: ${(props) => props.theme.colors.black};
`; 

export const CardInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  width: 100%;
`;

export const Title = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  font-weight: 600;
`;

export const Value = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  color: ${(props) => props.theme.colors.customDarkGray};

  .dark-icon img {
    filter: brightness(0.36);
    opacity: 0.8;
  }
`;

export const LastUpdateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;